import React from 'react'
import { GetTokenLocalStorage, GetUserRoleLocalStorage } from "../services/localStorage/localStorage"
import { Route, Navigate, Outlet, useNavigate } from "react-router";

const ProtectedRoute = ({ allowedRoles }) => {
    const token = GetTokenLocalStorage()
    const role = GetUserRoleLocalStorage()

    return (
        token && allowedRoles.includes(role) ? <Outlet /> : <Navigate to="/" />
    )
}

export default ProtectedRoute